var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#615F67",
    fillRule: "evenodd",
    d: "M0 0l42 20L0 40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNext);
export default __webpack_public_path__ + "static/media/slider-next.378ed76a05bcf00a8a5ca30a089124af.svg";
export { ForwardRef as ReactComponent };